import { BASE_PATH } from 'common/constants';
import { CDN_TYPE_CRM, imageUrlCDN } from 'common/utils/utils';

const IMG_BASE = `${BASE_PATH}/static/assets/images`;

export const BONUS_PLACEHOLDER_SRC = {
  casino: `${IMG_BASE}/bonus-placeholder-casino.png`,
  freespin: `${IMG_BASE}/bonus-placeholder-freespin.png`,
  sport: `${IMG_BASE}/bonus-placeholder-sport.png`,
};

export const resolveBonusPlaceholderSrc = ({ bonusType, isFreeSpin } = {}) => {
  if (isFreeSpin) return BONUS_PLACEHOLDER_SRC.freespin;
  if (bonusType === 'sport') return BONUS_PLACEHOLDER_SRC.sport;
  if (bonusType === 'casino') return BONUS_PLACEHOLDER_SRC.casino;
  return undefined;
};

export const resolveBonusImageUrl = imageLink =>
  imageLink ? imageUrlCDN(imageLink, CDN_TYPE_CRM) : undefined;
